 <template>
  <v-dialog v-model="dialog" max-width="750" persistent>
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{
          tecnico && !tecnico.id
            ? $vuetify.lang.t("$vuetify.NOVO_TECNICO")
            : $vuetify.lang.t("$vuetify.ATUALIZANDO_TECNICO")
        }}
      </v-card-title>

      <v-form ref="form" lazy-validation>
        <v-row class="ma-0 justify-center mb-n3 ml-7 mr-7">
          <v-col cols="5" class="ml-n2 mr-6">
            <v-row>
              <span
                class="
                  text-right
                  subtitle-2
                  font-weight-bold
                  grey--text
                  text--lighten-1
                "
              >
                {{ $vuetify.lang.t("$vuetify.NOME") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="tecnico.nome"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="3" class="mr-n2">
            <v-row>
              <span
                class="
                  text-right
                  subtitle-2
                  font-weight-bold
                  grey--text
                  text--lighten-1
                "
              >
                {{ "CPF" }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-text-field
                v-model.trim="tecnico.cpf"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
                v-mask="'###.###.###-##'"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="3" class="mr-n2 ml-8">
            <v-row>
              <span
                class="
                  text-right
                  subtitle-2
                  font-weight-bold
                  grey--text
                  text--lighten-1
                "
              >
                {{ $vuetify.lang.t("$vuetify.INSTALADORA") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-select
                :items="instaladoras"
                v-model="tecnico.instaladora"
                solo
                dense
                return-object
                item-text="nome"
                :rules="[
                      (v) =>
                        !!v || $vuetify.lang.t('$vuetify.CAMPO_OBRIGATORIO'),
                    ]"
              ></v-select>
            </v-row>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
          <span
            class="ml-4 caption red--text"
            v-show="showTecnicoAlreadyExists"
            >{{ $vuetify.lang.t("$vuetify.JA_EXISTE_TECNICO") }}</span
          >
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.resetValidation();
            $refs.form.reset();
            close();
          "
        >
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.validate();
            send(tecnico);
          "
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    tecnico: Object,
    instaladoras: Array,
    isLoading: Boolean,
    showTecnicoAlreadyExists: Boolean,
  },
  methods: {},
  data() {
    return {
      rules: [
        (v) =>
          (v && v.length >= 1) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
    });
  },
};
</script>